import { Component, OnInit, OnDestroy } from "@angular/core";
import { BaseFilterController } from "../BaseFilterController";
import { FormBuilder } from '@angular/forms';
import { DictionaryService, TableService } from "@amlCore/services";
import { TerroristFilter } from "@amlCore/models";
import { Subject } from 'rxjs';
import { IDictItemType } from "../../interfaces";
import { ClientTypeEnum } from "@amlCore/enums";
import { ActivatedRoute } from "@angular/router";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-terrorist-filter",
  templateUrl: "./terroristFilter.component.html"
})

export class TerroristFilterComponent extends BaseFilterController implements OnInit, OnDestroy {

  private $destroyed = new Subject();

  public selectObj = {
    typeSubjectList: [] as IDictItemType[]
  };

  placeholder = 'Поиск по ФИО, наименованию, ИНН';

  public filterObjectModel = new TerroristFilter();

  constructor(private fb: FormBuilder,
              protected tableSrv: TableService,
              private dictSrv: DictionaryService,
              protected activatedRoute: ActivatedRoute) {
    super(tableSrv, activatedRoute);
  }

  ngOnInit() {
    this.init();
    this.dictSrv.loadTypeClient().then(result => {
      this.selectObj.typeSubjectList = result.filter((item) => [ClientTypeEnum.LEGAL_ENTITY, ClientTypeEnum.INDIVIDUAL_PERSON].includes(item.code));
    });
    this.formModel.get("subjectType")
        .valueChanges
        .pipe(takeUntil(this.$destroyed))
        .subscribe((typeCode) => {
            this.selectedClientType({type: (typeCode || '')});
        });
  }

  public selectedClientType(data) {
    if (data.type === '') {
      return;
    }
    const currentSubjectTypeCode: string = data.type;
    const subjectTypeMap = {
      1: ["name", "inn", "ogrn"], // ClientTypeEnum.LEGAL_ENTITY
      2: ["name", "birthDate", "inn", "series", "number", 'sname', 'gname', 'pname'], // ClientTypeEnum.INDIVIDUAL_PERSON
    };
    const [disableSubjectTypeCode] = Object.keys(subjectTypeMap).filter((typeCode) => typeCode !== currentSubjectTypeCode);

    subjectTypeMap[disableSubjectTypeCode].forEach((field: string) => {
      this.formModel.get(field).disable();
    });
    subjectTypeMap[currentSubjectTypeCode].forEach((field: string) => {
      this.formModel.get(field).enable();
    });
  }

  /**
   * Метод создания формы
   * @return FormGroup
   */
  public createFormModel() {
    return this.fb.group(new TerroristFilter());
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.$destroyed.next();
    this.$destroyed.complete();
  }

  getStartFilterModel(): any {
    return {
      subjectType: ClientTypeEnum.LEGAL_ENTITY // тип субъекта
    } as TerroristFilter;
  }

  /**
   * Описания полей
   */
  public getFilterDescription(): any {
    return {
      subjectType: 'Тип субъекта',
      name: 'Наименование',
      sname: 'Фамилия',
      gname: 'Имя',
      pname: 'Отчество',
      birthDate: 'Дата рождения',
      inn: 'ИНН',
      series: 'Серия документа',
      number: 'Номер документа',
      ogrn: 'ОГРН',
      idSubject: 'Идентификатор'
    };
  }
}
